import qs from 'query-string';

const setQueryStringWithoutPageReload = (qsValue, shouldReplace) => {
  const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue}`;

  // replacing is for values the app derives on the user's behalf, so seeding
  // them leaves no history entry the user has to press back through
  if (shouldReplace) {
    window.history.replaceState({ path: newUrl }, '', newUrl);
    return;
  }

  window.history.pushState({ path: newUrl }, '', newUrl);
};

export const getQueryStringValue = (
  key,
  queryString = window.location.search,
) => {
  const values = qs.parse(queryString);
  return values[key];
};

export const setQueryStringValue = (
  key,
  value,
  queryString = window.location.search,
  { shouldReplace = false } = {},
) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({
    ...values,
    [key]: value,
  });
  setQueryStringWithoutPageReload(`?${newQsValue}`, shouldReplace);
};
